'use client';

import { useMemo } from 'react';
import { AdPlacement } from '@/features/ads/shared/types/ad-placement';
import { adAddUnitPathPrefix } from '@/features/ads/internal/helper/add-ad-unit-path-prefix';
import { useIsWTGamesApp } from '@/features/games-app-bridge/shared/hooks/use-is-wt-games-app';
import { useIsLg, useIsMd } from '@/shared/hooks/use-breakpoints';

const satisfiesBreakpointConstraints = (
  placement: AdPlacement,
  options: { isMd: boolean; isLg: boolean },
) => {
  const { constraints } = placement;
  if (!constraints) return true;

  if (constraints.minBp === 'lg' && !options.isLg) return false;
  if (constraints.maxBp === 'lg' && options.isLg) return false;
  if (constraints.minBp === 'md' && !options.isMd) return false;
  if (constraints.maxBp === 'md' && options.isMd) return false;

  return true;
};

export const useVisiblePlacements = (placements: AdPlacement[]) => {
  const isWtGamesApp = useIsWTGamesApp();
  const isMd = useIsMd();
  const isLg = useIsLg();

  const enrichedPlacements = useMemo(
    () => placements.map((placement) => adAddUnitPathPrefix(placement, isWtGamesApp)),
    [placements, isWtGamesApp],
  );

  return useMemo(
    () =>
      enrichedPlacements.filter((placement) =>
        satisfiesBreakpointConstraints(placement, { isMd, isLg }),
      ),
    [enrichedPlacements, isMd, isLg],
  );
};
